import { store, RequestUploadOptions } from "@store";

export function useUploadRequest(multiple = true) {
  const requestUpload = (options: RequestUploadOptions = {}) =>
    store().upload.requestFileUpload({ multiple, ...options });
  return { requestUpload };
}
